import type { GroupedExperience, GroupedExperiences } from '@axiom/validation';

const compareByDate = (
  endDateA: string | null | undefined,
  endDateB: string | null | undefined,
  startDateA: string | null | undefined,
  startDateB: string | null | undefined
): number => {
  if (!endDateA && endDateB) return -1;
  if (endDateA && !endDateB) return 1;
  if (endDateA && endDateB) {
    const endDiff = endDateB.localeCompare(endDateA);
    if (endDiff !== 0) return endDiff;
  }
  const startA = (startDateA as string | null) ?? '';
  const startB = (startDateB as string | null) ?? '';
  const startDiff = startB.localeCompare(startA);
  return startDiff === 0 ? 0 : startDiff;
};

export const GroupedExperiencesUtil = {
  splitHighlighted(groupedExperiences: GroupedExperiences[]) {
    const highlightedExperiences: GroupedExperience[] = [];
    const regularGroups: GroupedExperiences[] = [];

    for (const group of groupedExperiences) {
      const h = group.experiences.filter(e => e.isHighlighted);
      const r = group.experiences.filter(e => !e.isHighlighted);
      highlightedExperiences.push(...h);
      if (r.length > 0) {
        regularGroups.push({ ...group, experiences: r });
      }
    }

    highlightedExperiences.sort((a, b) => {
      const dateDiff = compareByDate(
        a.endDate,
        b.endDate,
        a.startDate,
        b.startDate
      );
      if (dateDiff !== 0) return dateDiff;
      const nameA = a.calculatedDisplayName ?? '';
      const nameB = b.calculatedDisplayName ?? '';
      return nameA.localeCompare(nameB);
    });

    regularGroups.sort((a, b) => {
      const expA = a.experiences[0];
      const expB = b.experiences[0];
      const dateDiff = compareByDate(
        expA?.endDate,
        expB?.endDate,
        expA?.startDate,
        expB?.startDate
      );
      if (dateDiff !== 0) return dateDiff;
      const nameA = expA?.calculatedDisplayName ?? '';
      const nameB = expB?.calculatedDisplayName ?? '';
      return nameA.localeCompare(nameB);
    });

    return { highlightedExperiences, regularGroups };
  },
};
